

import axiosInstance from "../../config";

export const verifyEmailToken = async (token) => {
  try {

    // passing token for verify email
    const response = await axiosInstance.post('/v1/mail-verified', { token }); 
   

    return {
      data: response.data,//return data response
      success: true // return success
    };
  } catch (error) {
    
    return {
      data: error.response?.data || { message: 'Something went wrong' },
      success: false
    };
  }
};